import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {timestampDate} from 'shared/tools';
import {User} from 'main/stores/users';

class UserApiKey extends DomainObject {
  id;
  label;
  apiKey;
  maskedApiKey;
  lastUsedAt;
  createdAt;
  active;

  _relations = {
    _dates: ['createdAt', 'lastUsedAt'],
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      label: observable,
      apiKey: observable,
      maskedApiKey: observable,
      lastUsedAt: observable,
      createdAt: observable,
      active: observable,
      lastUsedAtView: computed,
      createdAtView: computed
    });

    this.merge(other);
  }

  get lastUsedAtView() {
    return timestampDate(this.lastUsedAt);
  }

  get createdAtView() {
    return timestampDate(this.createdAt);
  }
}

export default UserApiKey;
